module.exports = __webpack_public_path__ + "static/media/RD_Team_image_3_edited_colour.ea57e3bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RD_Team_image_3_edited_colour.jpg
// module id = 129
// module chunks = 0